import { Box, Text, IconButton } from '@chakra-ui/react';
import { useContext } from 'react';
import { FaPencil } from 'react-icons/fa6';
import SubscriptionManagementContext, { SubscriptionManagementTrigger } from '../contexts/SubscriptionManagementContext';
import TabContext from '../contexts/TabContext';
import SubscriptionsContext from '../contexts/SubscriptionsContext';
import StepperContext from '../contexts/StepperContext';
import { INVOICE_TABS } from '../constants/enums';
import useCurrencyFormatter from '../hooks/useCurrencyFormatter';
import { useBreakpointsContext } from '../hooks/useBreakpointsContext';

const PalommaPlusBreakdownRow = (): JSX.Element => {
  const { setTabSelected } = useContext(TabContext);
  const { resetStepper } = useContext(StepperContext);
  const { totalSubscriptionAmount, subscriptionIvaBreakdown, hasActiveSubscription, experiments } =
    useContext(SubscriptionsContext);
  const { canManageSubscription } = useContext(SubscriptionManagementContext);
  const { isSmallScreen } = useBreakpointsContext();
  const formatCurrency = useCurrencyFormatter();

  if (!subscriptionIvaBreakdown) return <></>;

  const { base, iva } = subscriptionIvaBreakdown;

  return (
    <Box display={'flex'} flexDirection={'column'} gap={1}>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={1}>
          <Text fontWeight={400}>Palomma Plus</Text>
          {hasActiveSubscription && experiments?.isInPencilExperiment && (
            canManageSubscription ? (
              <SubscriptionManagementTrigger variant="icon" />
            ) : (
              <IconButton
                aria-label="Editar suscripción Palomma Plus"
                icon={<FaPencil />}
                type="button"
                variant="unstyled"
                size="xs"
                color={'gray.500'}
                display={'flex'}
                alignItems={'center'}
                minW="auto"
                _hover={{ color: 'gray.700' }}
                onClick={() => {
                  setTabSelected(INVOICE_TABS.PALOMMA_PLUS);
                  if (isSmallScreen) resetStepper(-1);
                }}
              />
            )
          )}
        </Box>
        <Text fontWeight={400}>{formatCurrency(totalSubscriptionAmount)}</Text>
      </Box>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} pl={4}>
        <Text fontSize={'0.875rem'} color={'gray.500'}>
          Beneficio
        </Text>
        <Text fontSize={'0.875rem'} color={'gray.500'}>
          {formatCurrency(base)}
        </Text>
      </Box>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} pl={4}>
        <Text fontSize={'0.875rem'} color={'gray.500'}>
          IVA
        </Text>
        <Text fontSize={'0.875rem'} color={'gray.500'}>
          {formatCurrency(iva)}
        </Text>
      </Box>
    </Box>
  );
};

export default PalommaPlusBreakdownRow;
